import type { FC, ReactNode } from "react";
import React, { createContext, useContext } from "react";

export type ABFeaturesStatus = "idle" | "loading" | "success" | "error";

export interface ABFeatureVariation {
  index?: number;
  evaluable?: boolean;
}

export interface ABFeaturesResult {
  status: ABFeaturesStatus;
  data: ReadonlyMap<string, ABFeatureVariation> | null;
}

const ABFeaturesContext = createContext<ABFeaturesResult | null>(null);

export interface ABFeaturesProviderProps {
  abFeatures?: ABFeaturesResult | null;
  children?: ReactNode;
}

export const ABFeaturesProvider: FC<ABFeaturesProviderProps> = ({
  abFeatures = null,
  children,
}) => (
  <ABFeaturesContext.Provider value={abFeatures}>
    {children}
  </ABFeaturesContext.Provider>
);

export const useABFeatures = (): ABFeaturesResult | null =>
  useContext(ABFeaturesContext);
